/**
 * @generated SignedSource<<267764f2e7fef0d24b47e8b810312cf5>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VatReportModal_seller$data = {
  readonly vatConfiguration: {
    readonly priceBookName: string | null;
  } | null;
  readonly " $fragmentType": "VatReportModal_seller";
};
export type VatReportModal_seller$key = {
  readonly " $data"?: VatReportModal_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"VatReportModal_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VatReportModal_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VatConfiguration",
      "kind": "LinkedField",
      "name": "vatConfiguration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceBookName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "7563e0fea109d6e7031562d65ffc7793";

export default node;
